const initialDeletionAuditLogs = { data: null, loading: true, cache: {} };

export const GetAllDeletionAuditLogsReducer = (state = initialDeletionAuditLogs, action) => {
  switch (action.type) {
    case "get_alldeletionauditlogs":
      return {
        ...state,
        data: action.payload,
        loading: action.loader ?? false,
        cache: action.cacheKey
          ? { ...state.cache, [action.cacheKey]: action.payload }
          : state.cache,
      };
    case "clear_deletionauditlogs_cache":
      return {
        ...state,
        cache: {},
      };
    default:
      return state;
  }
};
